import type { TextChunk } from './text-chunker';
import { logger } from '../logger';

export interface RunChunkedOptions<T> {
  onProgress?: (done: number, total: number) => void;
}

export async function runChunked<T>(
  chunks: TextChunk[],
  perChunk: (chunk: TextChunk, index: number) => Promise<T>,
  merge: (
    results: (T | null)[],
    chunks: TextChunk[],
    failedIndices: number[]
  ) => T,
  options?: RunChunkedOptions<T>
): Promise<T> {
  const results: (T | null)[] = new Array(chunks.length).fill(null);
  const failedIndices: number[] = [];

  for (let i = 0; i < chunks.length; i++) {
    try {
      results[i] = await perChunk(chunks[i]!, i);
    } catch (error) {
      logger.warn(
        `[chunk] chunk=${i + 1}/${chunks.length} chars=${chunks[i]!.text.length} ` +
          `failed: ${(error as Error).message}`
      );
      failedIndices.push(i);
    }
    options?.onProgress?.(i + 1, chunks.length);
  }

  if (failedIndices.length === chunks.length) {
    throw new Error(
      `All ${chunks.length} chunks failed. The document could not be processed.`
    );
  }

  return merge(results, chunks, failedIndices);
}
